/**
 * PDP "Order now" badge.
 *
 * The badge is rendered once by snippets/product-fast-shipping-label.liquid and
 * carries the ids of every variant whose `custom.order_now_label` metafield is
 * ticked. It is shown or hidden as the shopper switches variant, using the same
 * `venue:variant:updated` event the promo-code and info-notes blocks listen to
 * (dispatched by <variant-selects> in assets/theme.js).
 */
class FastShipLabel extends HTMLElement {
  constructor() {
    super();
    this.image = this.querySelector('.fast-ship-label');
    this.variantIds = (this.dataset.variantIds || '')
      .split(',')
      .map((id) => id.trim())
      .filter(Boolean);
    this.onVariantUpdate = this.onVariantUpdate.bind(this);
  }

  connectedCallback() {
    document.addEventListener('venue:variant:updated', this.onVariantUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener('venue:variant:updated', this.onVariantUpdate);
  }

  onVariantUpdate(event) {
    const variant = event.detail?.variant;
    if (!this.image || !variant) return;

    this.image.classList.toggle('hidden', !this.variantIds.includes(String(variant.id)));
  }
}

if (!customElements.get('fast-ship-label')) {
  customElements.define('fast-ship-label', FastShipLabel);
}
